<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="montantAnnuel?.montantMiniAnnuel"
    [label]="step5.getmontantminiannuel" [type]="'number'" [rule]="'digits_2'" [name]="getUid() + '_SepAtt_montantMiniAnnuel'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="montantAnnuel?.montantMaxiAnnuel"
    [label]="step5.getmontantmaxiannuel" [type]="'number'" [rule]="'digits_2'" [name]="getUid() + '_SepAtt_montantMaxiAnnuel'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="montantAnnuel?.devise" [label]="step5.getdevise"
[type]="'autocomplete'" 
[autoCompleteType]="'DEVISE'"
[autoCompleteTypeIndex]="0"
[rule]="'pattern_13'"
[errorMessage]="{}" [name]="getUid() + '_SepAtt_devise'">
</app-form-input>
